
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ShareDirectivesModule } from '../../../core/directives/directives.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { MaterialModule } from '../../modules/material/material.module';
import { ExpandTextClickComponent } from './expand-text-click.component';

@NgModule({
  declarations: [
    ExpandTextClickComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslationModule,
    NgbModule,
    ShareDirectivesModule,

  ],
  exports: [
    ExpandTextClickComponent
  ],

})
export class ExpandTextClickModule { }
